enum RequestType {
  FULL_REFUND = 'FULL_REFUND',
  PARTIAL_REFUND = 'PARTIAL_REFUND',
  SWAP = 'SWAP',
  PRICE_ERROR = 'PRICE_ERROR',
  NOT_SELECTED = '',
}

export default RequestType;
